// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"293":"component---src-pages-index-js","510":"component---src-pages-terms-js","745":"component---src-pages-privacy-js"}[chunkId] || chunkId) + "-" + {"293":"3b7951ff798e9be5cfee","454":"3d92724df1613ec7a677","510":"d9270292efc062889251","745":"bf896663f24e7a24c004"}[chunkId] + ".js";
};